import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Observable } from 'rxjs';
import { first } from 'rxjs/operators';
import { HubService } from 'src/app/shared/services/hub.service';
import { PermissionCheckService } from 'src/app/shared/services/permission-check.service';

@Component({
    selector: 'diana-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: false
})

export class HomeComponent implements OnInit {
  public hasViewAppointmentsPermission$!: Observable<boolean>;

  constructor(private route: ActivatedRoute, private hub: HubService, private permissionCheckService: PermissionCheckService) {
    this.hasViewAppointmentsPermission$ = this.permissionCheckService.hasViewAppointmentsPermission$();
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe((p: Params) => {
      const actionName = p.get('actionName');
      if (actionName) {
        const arr = actionName.split('?');
        const name: string = arr[0];
        let args: string = arr.length > 1 ? arr[1] : null;
        if (args === null) {
          this.route.queryParams.pipe(first()).subscribe(params => {
            args = '';
            for (const prop in params) {
              args += `${prop}=${params[prop]}&`;
            }
            args = args.slice(0, -1); // remove last &
          });
        }

        this.hub.onActionRecieved(name, args);
      }
    });
  }
}
